import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
var Meter = function (_a) {
    var actual = _a.actual, goal = _a.goal;
    var parsedActual = parseInt(String(actual), 10);
    var parsedGoal = parseInt(String(goal), 10);
    var percentage = (parsedActual / parsedGoal) * 100;
    var width = Math.min(100, Math.floor(percentage));
    if (!parsedGoal) {
        width = parsedActual ? 100 : 0;
    }
    var meterStyle = {
        width: "".concat(width, "%")
    };
    var fillClasses = classNames({
        'sb-card-meter-fill': true,
        yellow: width > 50 && width < 100,
        green: width === 100
    });
    return (_jsx("div", { className: "sb-card-meter-bar", children: _jsx("div", { className: fillClasses, style: meterStyle }) }));
};
export default Meter;
